import React from 'react';
import { Loader, useSelector } from '../Data/Imports';
import { Navigate } from 'react-router-dom';

const useAuth = () => {
	const { auth, isLoading } = useSelector((state) => state.auth);
	return { isLoading, auth };
};

export const ProtectedRoute = ({ children }) => {
	const { isLoading, auth } = useAuth();

	if (isLoading) {
		return (
			<div className='fixed inset-0 flex items-center justify-center bg-gray-100 bg-opacity-50 z-50'>
				<Loader />
			</div>
		);
	}

	if (!auth) {
		return <Navigate to='/dashboard' replace />;
	}

	return children;
};
